import ApiService from "../common/service.api";

export async function fetchMenu() {
  try {
    const response = await ApiService.get("/MenuManager/AppMenu");
    return response.data; 
  } catch (error) {
    console.error("Error fetching menu:", error);
    return []; 
  }
}
